import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'productcouponapp',
    template: `
        <div class="container-fluid p-4 coupon-admin">
            <div class="d-flex justify-content-between align-items-start mb-4">
                <div><h3 class="m-0">ROKSH termékkedvezmények</h3><p class="text-muted mb-0">Kuponok, érvényesség és termékhatókör kezelése</p></div>
                <button class="btn btn-primary" (click)="newCoupon()">+ Új kedvezmény</button>
            </div>

            <div class="alert alert-danger" role="alert" *ngIf="error">{{ error }}</div>
            <div class="alert alert-success" role="status" *ngIf="message">{{ message }}</div>

            <div class="card coupon-editor mb-4" *ngIf="editing">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <strong>{{ editing.RokshDiscountID ? 'Kedvezmény szerkesztése' : 'Új kedvezmény' }}</strong>
                    <button type="button" class="close" aria-label="Bezárás" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="card-body">
                    <h5>Alapadatok</h5>
                    <div class="row">
                        <div class="form-group col-md-4"><label>Belső név *</label><input class="form-control" maxlength="100" [(ngModel)]="editing.Name"></div>
                        <div class="form-group col-md-4"><label>Felhasználónak megjelenő név *</label><input class="form-control" maxlength="160" [(ngModel)]="editing.DisplayName"></div>
                        <div class="form-group col-md-4"><label>Kuponkép URL</label><div class="coupon-image-field"><button type="button" class="coupon-image-preview" *ngIf="editing.VisualUrl && !couponImageError" (click)="openCouponImage()" title="Kép megnyitása"><img [src]="editing.VisualUrl" (error)="couponImageError = true" alt="Kuponkép előnézete"></button><input class="form-control" type="url" [(ngModel)]="editing.VisualUrl" (ngModelChange)="couponImageError = false" placeholder="https://..."></div><small class="form-text text-danger" *ngIf="editing.VisualUrl && couponImageError">A kép nem tölthető be erről az URL-ről.</small></div>
                        <div class="form-group col-md-4"><label>Szegmens *</label><select class="form-control forceselect" [(ngModel)]="editing.RokshDiscountLevelID" (change)="onSegmentChange()"><option [ngValue]="null">Válassz szegmenst</option><option *ngFor="let segment of segments" [ngValue]="segment.RokshDiscountLevelID">{{segment.DisplayName}} — {{segment.ProviderName}} ({{segment.Segment}}){{segment.IsAvailable ? '' : ' — inaktív'}}</option></select><small class="form-text text-muted">A kiválasztott szegmens határozza meg a boltot és a jogosult felhasználókat.</small></div>
                        <div class="form-group col-md-4"><label>Kupon típusa *</label><select class="form-control forceselect" [(ngModel)]="editing.DiscountType"><option [ngValue]="1">Fix összegű kedvezmény</option><option [ngValue]="2">Százalékos kedvezmény</option><option [ngValue]="3">Egy termék ingyen</option></select></div>
                        <div class="form-group col-md-4" *ngIf="editing.DiscountType === 1"><label>Kedvezmény összege (Ft) *</label><input class="form-control" min="1" type="number" [(ngModel)]="editing.DiscountAmount"></div>
                        <div class="form-group col-md-4" *ngIf="editing.DiscountType === 2"><label>Kedvezmény mértéke (%) *</label><input class="form-control" min="0.01" max="100" step="0.01" type="number" [(ngModel)]="editing.DiscountPercent"></div>
                        <div class="col-md-4" *ngIf="editing.DiscountType === 3"><div class="alert alert-info mb-0">A kupon egy jogosult termék árát vonja le.</div></div>
                        <div class="form-group col-md-4">
                            <label>Célplatformok</label>
                            <select multiple class="form-control forceselect target-platform-select" [(ngModel)]="editing.TargetPlatformsArray">
                                <option *ngFor="let targetPlatform of allTargetPlatform" [value]="targetPlatform">{{targetPlatform}}</option>
                            </select>
                            <button type="button" class="btn btn-sm btn-outline-secondary mt-1" (click)="clearTargetPlatforms()">Kijelölések törlése</button>
                            <small class="form-text text-muted">Kijelölés nélkül minden platformon használható.</small>
                        </div>
                    </div>

                    <hr><h5>Felhasználás és érvényesség</h5>
                    <div class="row">
                        <div class="form-group col-md-3"><label>Maximális kedvezményes darabszám</label><input class="form-control" min="1" type="number" [(ngModel)]="editing.MaxQuantity"><small class="form-text text-muted">Üresen hagyva nincs darabkorlát.</small></div>
                        <div class="form-group col-md-3"><label>Felhasználható / felhasználó</label><input class="form-control" min="1" type="number" [(ngModel)]="editing.UsableTimesPerUser"><small class="form-text text-muted">Üresen hagyva nincs felhasználási korlát.</small></div>
                        <div class="form-group col-md-3"><label>Érvényes ettől *</label><input class="form-control" type="datetime-local" [(ngModel)]="editing.ValidFrom"></div>
                        <div class="form-group col-md-3"><label>Érvényes eddig *</label><input class="form-control" type="datetime-local" [(ngModel)]="editing.ValidTo"></div>
                    </div>
                    <div class="d-flex flex-wrap mt-2">
                        <div class="custom-control custom-checkbox mr-4"><input class="custom-control-input" id="active" type="checkbox" [(ngModel)]="editing.IsActive"><label class="custom-control-label" for="active">Aktív kupon</label></div>
                        <div class="custom-control custom-checkbox mr-4"><input class="custom-control-input" id="combine" type="checkbox" [(ngModel)]="editing.IsCombinable"><label class="custom-control-label" for="combine">Régi kuponnal összevonható</label></div>
                        <div class="custom-control custom-checkbox"><input class="custom-control-input" id="all" type="checkbox" [(ngModel)]="editing.AppliesToAllQuantity"><label class="custom-control-label" for="all">Minden jogosult mennyiségre érvényes</label></div>
                    </div>

                    <hr><div class="d-flex justify-content-between align-items-start"><div><h5 class="mb-1">Termékhatókör</h5><p class="text-muted small">Legalább egy feltételt adj meg.</p></div><select class="form-control forceselect scope-logic" [(ngModel)]="editing.LogicType"><option [ngValue]="1">Bármelyik feltétel (VAGY)</option><option [ngValue]="2">Minden feltétel (ÉS)</option></select></div>
                    <div class="row">
                        <div class="form-group col-md-6 scope-picker">
                            <label>Termékek</label>
                            <div><button type="button" class="btn btn-sm btn-outline-primary mb-2" [disabled]="!editing.RokshDiscountLevelID" (click)="openProductPicker()">Kiválasztás <i class="fa fa-plus"></i></button></div>
                            <div class="selected-product-list" *ngIf="selectedProducts.length">
                                <div class="selected-product-card" *ngFor="let item of selectedProducts">
                                    <img [src]="item.ImageUrl || '/images/missing.jpg'" alt=""><div><strong>{{item.Name}}</strong><small>ProductID: {{item.ID}}</small></div>
                                    <button type="button" (click)="removeProduct(item.ID)" aria-label="Eltávolítás"><i class="fa fa-trash"></i></button>
                                </div>
                            </div>
                            <small class="form-text text-muted" *ngIf="!selectedProducts.length">Még nincs kiválasztott termék. Előbb válassz szegmenst.</small>
                        </div>
                        <div class="form-group col-md-6 scope-picker">
                            <label>Kategóriák</label>
                            <input class="form-control" [(ngModel)]="categoryQuery" (input)="queueCategorySearch()" (focus)="searchCategories()" placeholder="Keresés kategórianév vagy ID alapján" autocomplete="off">
                            <div class="scope-results" *ngIf="showCategoryResults">
                                <button type="button" *ngFor="let item of categoryResults" (click)="addCategory(item)"><span><strong>{{item.Name || 'Névtelen kategória'}}</strong><small>Kategória ID: {{item.ID}}</small></span></button>
                                <div class="scope-empty" *ngIf="!categorySearching && !categoryResults.length">Nincs találat.</div>
                            </div>
                            <div class="scope-selection" *ngIf="selectedCategories.length">
                                <span class="scope-chip" *ngFor="let item of selectedCategories">{{item.Name}} <small>#{{item.ID}}</small><button type="button" (click)="removeCategory(item.ID)" aria-label="Eltávolítás">&times;</button></span>
                            </div>
                            <small class="form-text text-muted">A szegmenshez tartozó bolt kategóriái.</small>
                        </div>
                        <div class="form-group col-md-4"><label>Márkák</label><input class="form-control" [(ngModel)]="scopeBrands" placeholder="pl. Coca-Cola, Soproni"></div>
                        <div class="form-group col-md-4"><label>Címkék</label><input class="form-control" [(ngModel)]="scopeLabels" placeholder="pl. akciós, nyári"></div>
                        <div class="form-group col-md-4"><label>Kulcsszavak</label><input class="form-control" [(ngModel)]="scopeKeywords" placeholder="pl. sör, üdítő"></div>
                    </div>
                    <div class="d-flex justify-content-end mt-2"><button class="btn btn-light mr-2" (click)="cancel()">Mégse</button><button class="btn btn-success" [disabled]="saving" (click)="save()">{{ saving ? 'Mentés…' : 'Kedvezmény mentése' }}</button></div>
                </div>
            </div>

            <div class="card">
                <div class="table-responsive"><table class="table table-hover mb-0"><thead><tr><th>Kedvezmény</th><th>Szegmens</th><th>Típus</th><th>Célplatformok</th><th>Érvényesség</th><th>Állapot</th><th class="text-right">Műveletek</th></tr></thead>
                <tbody><tr *ngFor="let coupon of coupons"><td><strong>{{coupon.DisplayName}}</strong><small class="d-block text-muted">{{coupon.Name}}</small></td><td>{{segmentName(coupon.RokshDiscountLevelID)}}</td><td>{{typeName(coupon.DiscountType)}}</td><td>{{coupon.TargetPlatforms || 'Mindegyik'}}</td><td>{{coupon.ValidFrom | date:'yyyy.MM.dd'}} – {{coupon.ValidTo | date:'yyyy.MM.dd'}}</td><td><span class="badge" [class.badge-success]="coupon.IsActive" [class.badge-secondary]="!coupon.IsActive">{{coupon.IsActive ? 'Aktív' : 'Inaktív'}}</span></td><td class="text-right"><button class="btn btn-sm btn-outline-primary mr-2" (click)="edit(coupon)">Szerkesztés</button><button *ngIf="coupon.IsActive" class="btn btn-sm btn-outline-danger" (click)="deactivate(coupon)">Kikapcsolás</button></td></tr><tr *ngIf="!coupons.length"><td colspan="7" class="text-center text-muted py-5">Még nincs rögzített kedvezmény.</td></tr></tbody></table></div>
            </div>

            <ng-template #productPickerTemplate>
                <div class="modal-header">
                    <h5 class="modal-title">Kapcsolódó termékek kiválasztása</h5>
                    <button type="button" class="close" aria-label="Bezárás" (click)="productPickerRef.hide()"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body product-picker-modal">
                    <div class="row align-items-center mb-3">
                        <div class="col-md-4">
                            <div class="input-group"><input class="form-control" type="search" [(ngModel)]="modalProductSearch" placeholder="Termék keresése"><span class="input-group-append"><span class="input-group-text bg-transparent"><i class="fa fa-search"></i></span></span></div>
                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                            <label class="mb-0 mr-2">Kategória:</label>
                            <select class="form-control forceselect" [(ngModel)]="modalCategoryID" (change)="loadModalProducts()"><option [ngValue]="null">Válassz kategóriát</option><option *ngFor="let category of modalCategories" [ngValue]="category.ID">{{category.Name}} ({{category.ID}})</option></select>
                        </div>
                        <div class="col-md-2 text-right"><button type="button" class="btn btn-outline-dark" (click)="finishProductSelection()">Kész!</button></div>
                    </div>
                    <div class="text-center p-4" *ngIf="modalProductsLoading"><i class="fa-2x fa fa-spinner fa-spin fa-fw"></i></div>
                    <div class="product-picker-grid" *ngIf="!modalProductsLoading">
                        <button type="button" class="product-picker-card" *ngFor="let product of modalProducts | filter:modalProductSearch" (click)="toggleModalProduct(product)" [class.selected]="isModalProductSelected(product.ID)">
                            <img [lazyLoad]="product.ImageUrl" [defaultImage]="'/images/missing.jpg'" alt=""><span>{{product.Name}}</span><small>ProductID: {{product.ID}}</small><i class="fa fa-check" *ngIf="isModalProductSelected(product.ID)"></i>
                        </button>
                        <div class="text-muted p-4" *ngIf="modalCategoryID && !(modalProducts | filter:modalProductSearch).length">Nincs találat.</div>
                        <div class="text-muted p-4" *ngIf="!modalCategoryID">Válassz kategóriát a termékek megjelenítéséhez.</div>
                    </div>
                </div>
            </ng-template>

            <ng-template #couponImageTemplate>
                <div class="modal-header">
                    <h5 class="modal-title">Kuponkép</h5>
                    <button type="button" class="close" aria-label="Bezárás" (click)="couponImageRef.hide()"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body coupon-image-modal"><img [src]="editing.VisualUrl" alt="Kuponkép"></div>
            </ng-template>
        </div>`,
    styles: [`
        .coupon-admin { max-width: 1440px; }
        .coupon-editor { border-top: 3px solid #713495; }
        .coupon-editor h5 { color: #4c3d52; font-weight: 600; }
        .coupon-editor label { font-size: 13px; font-weight: 600; }
        .scope-logic { max-width: 230px; }
        .target-platform-select { min-height: 150px; }
        .coupon-image-field { display: flex; align-items: center; gap: 9px; }
        .coupon-image-preview { flex: 0 0 54px; width: 54px; height: 54px; padding: 3px; border: 1px solid #ddd; border-radius: 4px; background: #fff; cursor: zoom-in; }
        .coupon-image-preview img { width: 100%; height: 100%; object-fit: contain; }
        .coupon-image-field input { min-width: 0; }
        .coupon-image-modal { display: flex; justify-content: center; align-items: center; min-height: 300px; max-height: 75vh; }
        .coupon-image-modal img { max-width: 100%; max-height: 70vh; object-fit: contain; }
        .scope-picker { position: relative; }
        .scope-results { position: absolute; z-index: 20; top: 66px; left: 15px; right: 15px; max-height: 270px; overflow-y: auto; background: #fff; border: 1px solid #ced4da; border-radius: 0 0 4px 4px; box-shadow: 0 5px 14px rgba(0,0,0,.14); }
        .scope-results > button { display: flex; align-items: center; width: 100%; padding: 9px 12px; border: 0; border-bottom: 1px solid #eee; background: #fff; text-align: left; }
        .scope-results > button:hover { background: #f7effb; }
        .scope-results img { width: 36px; height: 36px; object-fit: contain; margin-right: 10px; }
        .scope-results span { min-width: 0; }
        .scope-results strong, .scope-results small { display: block; }
        .scope-results strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .scope-results small { color: #756a79; }
        .scope-empty { padding: 12px; color: #756a79; }
        .scope-selection { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
        .scope-chip { display: inline-flex; align-items: center; max-width: 100%; padding: 5px 7px 5px 10px; color: #57246f; background: #f5eafb; border: 1px solid #dcb9ef; border-radius: 16px; }
        .scope-chip small { margin-left: 5px; color: #756a79; }
        .scope-chip button { margin-left: 7px; padding: 0 3px; color: #57246f; border: 0; background: transparent; font-size: 18px; line-height: 16px; }
        .selected-product-list { display: flex; flex-wrap: wrap; gap: 8px; }
        .selected-product-card { display: flex; align-items: center; width: calc(50% - 4px); min-height: 64px; padding: 7px; border: 1px solid #ddd; border-radius: 4px; background: #fff; }
        .selected-product-card img { width: 48px; height: 48px; margin-right: 8px; object-fit: contain; }
        .selected-product-card div { min-width: 0; flex: 1; }
        .selected-product-card strong, .selected-product-card small { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .selected-product-card small { color: #756a79; }
        .selected-product-card button { border: 0; background: transparent; color: #777; }
        .product-picker-modal { min-height: 620px; }
        .product-picker-grid { display: flex; flex-wrap: wrap; align-content: flex-start; max-height: 540px; overflow-y: auto; }
        .product-picker-card { position: relative; width: 175px; height: 225px; margin: 4px; padding: 14px 10px; border: 1px solid #ddd; border-radius: 4px; background: #fff; text-align: center; }
        .product-picker-card:hover { border-color: #8bc7e8; box-shadow: 0 2px 7px rgba(0,0,0,.12); }
        .product-picker-card.selected { background: #add8e6; border-color: #55a8d2; }
        .product-picker-card img { display: block; width: 130px; height: 130px; margin: 0 auto 7px; object-fit: contain; }
        .product-picker-card span, .product-picker-card small { display: block; overflow: hidden; }
        .product-picker-card span { max-height: 42px; }
        .product-picker-card small { color: #6b616e; }
        .product-picker-card > i { position: absolute; top: 7px; right: 7px; color: #247da7; }
        th { color: #6b616e; font-size: 12px; text-transform: uppercase; }
        td { vertical-align: middle; }
    `],
})
export class ProductCouponComponent implements OnInit {
    @ViewChild('productPickerTemplate') private productPickerTemplate: TemplateRef<any>;
    @ViewChild('couponImageTemplate') private couponImageTemplate: TemplateRef<any>;

    coupons: any[] = [];
    segments: any[] = [];
    editing: any;
    selectedProducts: any[] = [];
    selectedCategories: any[] = [];
    categoryQuery = '';
    categoryResults: any[] = [];
    categorySearching = false;
    showCategoryResults = false;
    private categorySearchTimer: any;
    productPickerRef: BsModalRef;
    couponImageRef: BsModalRef;
    modalCategories: any[] = [];
    modalProducts: any[] = [];
    modalSelectedProducts: any[] = [];
    modalCategoryID: number = null;
    modalProductSearch = '';
    modalProductsLoading = false;
    scopeBrands = '';
    scopeLabels = '';
    scopeKeywords = '';
    saving = false;
    error = '';
    message = '';
    couponImageError = false;

    allTargetPlatform: string[] = [
        'ROKSH_DESKTOP_HUN',
        'ROKSH_DESKTOP_AUT',
        'ROKSH_MOBILE_HUN',
        'ROKSH_MOBILE_AUT',
        'ALDI_HUN',
        'ALDI_CHE',
        'MOL_MOBILE_HUN'
    ];

    constructor(private http: HttpClient, private modalService: BsModalService) {}

    ngOnInit() { this.load(); this.loadSegments(); }

    loadSegments() {
        this.http.get<any[]>('/product-coupons/segments', this.authOptions()).subscribe(
            segments => this.segments = segments,
            () => this.error = 'A szegmensek nem tölthetők be.'
        );
    }

    load() {
        this.http.get<any[]>('/product-coupons', this.authOptions()).subscribe(
            coupons => this.coupons = coupons,
            () => this.error = 'A kedvezmények nem tölthetők be.'
        );
    }

    newCoupon() {
        const now = new Date();
        const end = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
        this.editing = { IsActive: true, IsCombinable: true, AppliesToAllQuantity: false, UsableTimesPerUser: 1, DiscountType: 1, LogicType: 1, TargetPlatforms: null, TargetPlatformsArray: [], ValidFrom: this.localDate(now), ValidTo: this.localDate(end) };
        this.couponImageError = false;
        this.setScopes();
    }

    edit(coupon: any) {
        this.editing = {
            ...coupon,
            UsableTimesPerUser: coupon.UsableTimesPerUser > 0 ? coupon.UsableTimesPerUser : null,
            TargetPlatformsArray: coupon.TargetPlatforms ? coupon.TargetPlatforms.split(',').map(item => item.trim()) : [],
            ValidFrom: this.localDate(new Date(coupon.ValidFrom)),
            ValidTo: this.localDate(new Date(coupon.ValidTo))
        };
        this.couponImageError = false;
        this.setScopes(coupon);
    }

    cancel() { this.editing = null; this.error = ''; }

    save() {
        this.error = '';
        if (!this.editing.Name || !this.editing.DisplayName || !this.editing.RokshDiscountLevelID || !this.editing.ValidFrom || !this.editing.ValidTo) {
            this.error = 'Töltsd ki a csillaggal jelölt mezőket.';
            return;
        }
        if (new Date(this.editing.ValidFrom) >= new Date(this.editing.ValidTo)) {
            this.error = 'Az érvényesség vége legyen későbbi a kezdésnél.';
            return;
        }
        if (this.editing.DiscountType === 1 && !(this.editing.DiscountAmount > 0)) {
            this.error = 'Add meg a fix kedvezmény összegét.';
            return;
        }
        if (this.editing.DiscountType === 2 && !(this.editing.DiscountPercent > 0 && this.editing.DiscountPercent <= 100)) {
            this.error = 'A százalékos kedvezmény 0-nál nagyobb és legfeljebb 100 lehet.';
            return;
        }
        const productIDs = this.selectedProducts.map(item => item.ID);
        const categoryIDs = this.selectedCategories.map(item => item.ID);
        const brands = this.textList(this.scopeBrands);
        const labels = this.textList(this.scopeLabels);
        const keywords = this.textList(this.scopeKeywords);
        if (!productIDs.length && !categoryIDs.length && !brands.length && !labels.length && !keywords.length) {
            this.error = 'Adj meg legalább egy termékhatókört.';
            return;
        }
        Object.assign(this.editing, {
            UsableTimesPerUser: this.editing.UsableTimesPerUser || 0,
            TargetPlatforms: this.editing.TargetPlatformsArray && this.editing.TargetPlatformsArray.length
                ? this.editing.TargetPlatformsArray.join(',')
                : null,
            Products: productIDs.map(ProductID => ({ ProductID })),
            Categories: categoryIDs.map(CategoryID => ({ CategoryID })),
            Brands: brands.map(Brand => ({ Brand })),
            Labels: labels.map(Label => ({ Label })),
            Keywords: keywords.map(Keyword => ({ Keyword })),
            DiscountAmount: this.editing.DiscountType === 1 ? this.editing.DiscountAmount : null,
            DiscountPercent: this.editing.DiscountType === 2 ? this.editing.DiscountPercent : null,
        });
        if (this.editing.DiscountType === 3) {
            this.editing.AppliesToAllQuantity = false;
            this.editing.MaxQuantity = 1;
        }
        this.saving = true;
        this.http.post('/product-coupons', this.editing, this.authOptions()).subscribe(
            () => { this.saving = false; this.editing = null; this.message = 'A kedvezményt elmentettük.'; this.load(); },
            () => { this.saving = false; this.error = 'A kedvezmény mentése nem sikerült. Ellenőrizd a megadott adatokat.'; }
        );
    }

    deactivate(coupon: any) {
        this.http.delete('/product-coupons/' + coupon.RokshDiscountID, this.authOptions()).subscribe(
            () => { this.message = 'A kedvezményt kikapcsoltuk.'; this.load(); },
            () => this.error = 'A kedvezmény kikapcsolása nem sikerült.'
        );
    }

    clearTargetPlatforms() { this.editing.TargetPlatformsArray = []; }

    typeName(type: number) { return type === 1 ? 'Fix összeg' : type === 2 ? 'Százalék' : 'Ingyenes termék'; }

    segmentName(id: number) {
        const segment = this.segments.find(item => item.RokshDiscountLevelID === id);
        return segment ? segment.DisplayName + ' — ' + segment.ProviderName : 'Ismeretlen szegmens (#' + id + ')';
    }

    onSegmentChange() {
        this.selectedProducts = [];
        this.selectedCategories = [];
        this.categoryQuery = '';
        this.categoryResults = [];
        this.modalCategories = [];
        this.modalProducts = [];
    }

    private setScopes(coupon: any = {}) {
        this.selectedProducts = (coupon.Products || []).map((item: any) => ({ ID: item.ProductID, Name: 'Betöltés…', ImageUrl: '/images/missing.jpg' }));
        this.selectedCategories = (coupon.Categories || []).map((item: any) => ({ ID: item.CategoryID, Name: 'Betöltés…' }));
        this.categoryQuery = '';
        this.categoryResults = [];
        this.showCategoryResults = false;
        this.resolveSelectedNames();
        this.scopeBrands = (coupon.Brands || []).map((item: any) => item.Brand).join(', ');
        this.scopeLabels = (coupon.Labels || []).map((item: any) => item.Label).join(', ');
        this.scopeKeywords = (coupon.Keywords || []).map((item: any) => item.Keyword).join(', ');
    }

    queueCategorySearch() { clearTimeout(this.categorySearchTimer); this.categorySearchTimer = setTimeout(() => this.searchCategories(), 250); }

    searchCategories() {
        this.categorySearching = true;
        this.searchScope('categories', this.categoryQuery, items => { this.categoryResults = items; this.categorySearching = false; this.showCategoryResults = true; });
    }

    addCategory(item: any) { if (!this.selectedCategories.some(x => x.ID === item.ID)) this.selectedCategories.push(item); this.categoryQuery = ''; this.showCategoryResults = false; }
    removeProduct(id: number) { this.selectedProducts = this.selectedProducts.filter(item => item.ID !== id); }
    removeCategory(id: number) { this.selectedCategories = this.selectedCategories.filter(item => item.ID !== id); }

    openProductPicker() {
        if (!this.editing.RokshDiscountLevelID) return;
        this.modalSelectedProducts = this.selectedProducts.map(item => ({ ...item }));
        this.modalProducts = [];
        this.modalCategoryID = null;
        this.modalProductSearch = '';
        this.productPickerRef = this.modalService.show(this.productPickerTemplate, { class: 'modal-lg' });
        this.searchScope('categories', '', items => this.modalCategories = items);
    }

    openCouponImage() {
        this.couponImageRef = this.modalService.show(this.couponImageTemplate, { class: 'modal-lg' });
    }

    loadModalProducts() {
        this.modalProductSearch = '';
        this.modalProducts = [];
        if (!this.modalCategoryID) return;
        this.modalProductsLoading = true;
        this.searchScope('products', '', items => { this.modalProducts = items; this.modalProductsLoading = false; }, this.modalCategoryID);
    }

    toggleModalProduct(product: any) {
        const index = this.modalSelectedProducts.findIndex(item => item.ID === product.ID);
        if (index < 0) this.modalSelectedProducts.push(product);
        else this.modalSelectedProducts.splice(index, 1);
    }

    isModalProductSelected(id: number) { return this.modalSelectedProducts.some(item => item.ID === id); }

    finishProductSelection() {
        this.selectedProducts = this.modalSelectedProducts.map(item => ({ ...item }));
        this.productPickerRef.hide();
    }

    private searchScope(type: string, query: string, done: (items: any[]) => void, categoryID?: number) {
        const segmentID = Number(this.editing && this.editing.RokshDiscountLevelID);
        if (!segmentID) { done([]); return; }
        const category = categoryID ? '&categoryID=' + categoryID : '';
        this.http.get<any[]>('/product-coupons/scope/' + type + '?segmentID=' + segmentID + '&query=' + encodeURIComponent(query || '') + category, this.authOptions())
            .subscribe(done, () => done([]));
    }

    private resolveSelectedNames() {
        this.selectedProducts.forEach(selected => this.searchScope('products', String(selected.ID), items => {
            const match = items.find(item => item.ID === selected.ID); if (match) Object.assign(selected, match);
        }));
        this.selectedCategories.forEach(selected => this.searchScope('categories', String(selected.ID), items => {
            const match = items.find(item => item.ID === selected.ID); if (match) Object.assign(selected, match);
        }));
    }

    private textList(value: string): string[] { return (value || '').split(',').map(item => item.trim()).filter((item, index, all) => !!item && all.indexOf(item) === index); }
    private localDate(value: Date): string { const offset = value.getTimezoneOffset() * 60000; return new Date(value.getTime() - offset).toISOString().slice(0, 16); }
    private authOptions() {
        return { headers: new HttpHeaders({ Authorization: 'Bearer ' + sessionStorage.getItem('jwtToken') }) };
    }
}
